import { SystemService } from './../../service/system.service';
/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE CLASS NAME*/
import { Injectable } from '@angular/core';

@Injectable()
export class utilityService {
    systemS: SystemService = new SystemService();
    isAPI19() {
        if (this.systemS.isAndroid()) {
            const androidVersion = this.systemS.getAndroidVersion();
            if (androidVersion) {
                if (androidVersion.charAt(0) === '4') {
                    return true;
                }
            }
        }
        return false;
    }

    applyConditionalCss() {
        if (this.isAPI19()) {
            // in API 19 app-sidenav takes the full screen height
            // so for mobile screen in api 19 a margin-top 56px is applied
            // so that the content comes below toolbar
            const sidenavs = document.querySelectorAll('.app-sidenav');
            for (let i = 0; i < sidenavs.length; i++) {
                sidenavs[i]['style']['marginTop'] = '56px';
            }
        }
    }
}


// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/services/utility/utility.service.ts